//ai文献解析状态
const AI_EXTRACT_STATUS = {
  NOTSTART: 0, //未进行
  PENDING: 1, //进行中
  SUCCESS: 2, //已完成
  FAIL: 3, //生成失败
  SUCCESS_UPDATE: 4, //已完成需要更新
  FAIL_IGNORE: 5, //失败忽略
};

export { AI_EXTRACT_STATUS };
